
<!--
    @name: 跳转记工记账弹窗
    @description:
    @author: 徐朝成 xcc614@qq.com
    @time: 2021-09-23 11:52:28
-->
<template>
  <div>
    <el-dialog title="请选择" :visible.sync="show" width="400px" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-row>
        <el-col :span="12" v-permission-hide="{type:['person']}">
          <div @click="topath(1)" style="cursor: pointer">
            <img src="@/assets/bannerIcon/record/type1.png" alt="">
            <div class="t_context">个人记工</div>
          </div>
        </el-col>
        <el-col :span="12" v-permission-hide="{type:['person']}">
          <div @click="godetail(1)" style="cursor: pointer">
            <img src="@/assets/bannerIcon/record/type3.png" alt="">
            <div class="t_context">个人记账</div>
          </div>
        </el-col>
        <el-col :span="12" v-permission-hide="{type:['company', 'team', 'organization']}">
          <div @click="topath(2)" style="cursor: pointer">
            <img src="@/assets/bannerIcon/record/type2.png" alt="">
            <div class="t_context">班组记工</div>
          </div>
        </el-col>
        <el-col :span="12"  v-permission-hide="{type:['company', 'team', 'organization']}">
          <div @click="info(2)" style="cursor: pointer">
            <img src="@/assets/bannerIcon/record/type4.png" alt="">
            <div class="t_context">班组记账</div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "record",
  data(){
    return {
      show:false,
      path:''
    }
  },
  methods:{
    topath(type=1){
      window.open(`${this.path}?type=${type}`)
    },
    info(type=2){
      window.open(`TeamRecord?type=${type}`)
    },
    godetail(type=1){
       window.open(`IndividualRecord?type=${type}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.t_title{
  color: #333333;
  font-size: 16px;
}
.t_context{
  cursor: pointer;
  color: #333333;
  font-size: 14px;
  margin: 10px auto;
}
.el-col-12{
  text-align: center;
  margin: 30px 0 20px;
}
/deep/.el-dialog__body{
  border-top: #DFE4EA 1px solid;
  padding: 0 37px;
}
/deep/.el-dialog__footer{
  .el-button{
    margin: 0;
  }
  .el-button+.el-button {
    margin-left: 20px;
  }
}
</style>
